import { t } from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { appDanger, appSuccess } from '../app_alerts/slice';
import { getOrganizationSlug } from '../organizations/selectors';
import { getCarouselDevices, getLockDevices, setCarouselDevice, setLockDevice } from './data';
import { errorReceiveCarouselDevices, errorReceiveLockDevices, errorReceiveSetCarouselDevice, errorReceiveSetLockDevice, failedReceiveCarouselDevices, failedReceiveLockDevices, failedReceiveSetCarouselDevice, failedReceiveSetLockDevice, receiveCarouselDevices, receiveLockDevices, receiveSetCarouselDevice, receiveSetLockDevice } from './slice';
export function* requestCarouselDevices(action) {
    try {
        const { consumerAPI, locationSlug } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getCarouselDevices, organization, locationSlug, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveCarouselDevices());
            }
            else if (data) {
                if (data.length < 1) {
                    throw new Error(t('NO_DEVICES_AVAILABLE', {
                        ns: 'Common'
                    }));
                }
                yield put(receiveCarouselDevices(data));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveCarouselDevices());
            }
            else if (response && response.status === 200) {
                if (response.data.length < 1) {
                    throw new Error(t('NO_DEVICES_AVAILABLE', {
                        ns: 'Common'
                    }));
                }
                yield put(receiveCarouselDevices(response.data));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveCarouselDevices());
    }
}
export function* requestLockDevices(action) {
    try {
        const { consumerAPI, locationSlug } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getLockDevices, organization, locationSlug, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveLockDevices());
            }
            else if (data) {
                if (data.length < 1) {
                    throw new Error(t('NO_DEVICES_AVAILABLE', {
                        ns: 'Common'
                    }));
                }
                yield put(receiveLockDevices(data));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveLockDevices());
            }
            else if (response && response.status === 200) {
                if (response.data.length < 1) {
                    throw new Error(t('NO_DEVICES_AVAILABLE', {
                        ns: 'Common'
                    }));
                }
                yield put(receiveLockDevices(response.data));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveLockDevices());
    }
}
export function* requestSetCarouselDevice(action) {
    try {
        const { consumerAPI, deviceId, locationSlug, setting } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(setCarouselDevice, organization, locationSlug, deviceId, setting, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveSetCarouselDevice());
                yield put(appDanger(t('ERROR_RECEIVE_SET_DEVICE_CAROUSEL', {
                    ns: 'Common'
                })));
            }
            else if (data) {
                yield put(receiveSetCarouselDevice(data));
                yield put(appSuccess(`${t('SUCCESS_RECEIVE_SET_DEVICE_CAROUSEL', {
                    ns: 'Common'
                })} ${setting}`));
            }
            else {
                throw new Error(t('FAILED_RECEIVE_SET_DEVICE_CAROUSEL', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveSetCarouselDevice());
                yield put(appDanger(t('ERROR_RECEIVE_SET_DEVICE_CAROUSEL', {
                    ns: 'Common'
                })));
            }
            else if (response && response.status === 200) {
                yield put(receiveSetCarouselDevice(response.data));
                yield put(appSuccess(`${t('SUCCESS_RECEIVE_SET_DEVICE_CAROUSEL', {
                    ns: 'Common'
                })} ${setting}`));
            }
            else {
                throw new Error(t('FAILED_RECEIVE_SET_DEVICE_CAROUSEL', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveSetCarouselDevice());
        yield put(appDanger(t('FAILED_RECEIVE_SET_DEVICE_CAROUSEL', {
            ns: 'Common'
        })));
    }
}
export function* requestSetLockDevice(action) {
    try {
        const { consumerAPI, deviceId, locationSlug, setting } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(setLockDevice, organization, locationSlug, deviceId, setting, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveSetLockDevice());
                yield put(appDanger(t('ERROR_RECEIVE_SET_DEVICE_LOCK', {
                    ns: 'Common'
                })));
            }
            else if (data) {
                yield put(receiveSetLockDevice(data));
                yield put(appSuccess(t('SUCCESS_RECEIVE_SET_DEVICE_LOCK', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_RECEIVE_SET_DEVICE_LOCK', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveSetLockDevice());
                yield put(appDanger(t('ERROR_RECEIVE_SET_DEVICE_LOCK', {
                    ns: 'Common'
                })));
            }
            else if (response && response.status === 200) {
                yield put(receiveSetLockDevice(response.data));
                yield put(appSuccess(t('SUCCESS_RECEIVE_SET_DEVICE_LOCK', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_RECEIVE_SET_DEVICE_LOCK', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveSetLockDevice());
        yield put(appDanger(t('FAILED_RECEIVE_SET_DEVICE_LOCK', {
            ns: 'Common'
        })));
    }
}
export function* watchRequestCarouselDevices() {
    yield takeLatest('devices/requestCarouselDevices', requestCarouselDevices);
}
export function* watchRequestLockDevices() {
    yield takeLatest('devices/requestLockDevices', requestLockDevices);
}
export function* watchRequestSetCarouselDevice() {
    yield takeLatest('devices/requestSetCarouselDevice', requestSetCarouselDevice);
}
export function* watchRequestSetLockDevice() {
    yield takeLatest('devices/requestSetLockDevice', requestSetLockDevice);
}
